import React, { Component } from 'react'

import './ContactPage.css'
import Header from '../header/Header';

import hatchGarage from './../../img/hatch/garage.jpeg'
import Footer from '../footer/Footer';

import glassEffect from './../../img/glass-screen-effect.png'
import emailIcon from './../../img/email-icon.png'
import instagramIcon from './../../img/insta-icon.png'
import linkedinIcon from './../../img/linkedin-icon.png'

export class ContactPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    setTimeout(function() {
      document.getElementById('contact-showcase').style.opacity = 1
    },100)
  }

  render() {

    return (
      <div className="contact-page-container">
        <Header/>
        <div id="contact-showcase">
          <img id="contact-image" src={hatchGarage} alt=""/>
          <div className="contact-overlay"></div>

          <div className="contact-content">

            <h1 className="contact-title">
              <span>Contact Us</span>
            </h1>


            <div className="glass-wrapper">

                <div className='glass-links'>

                  <a
                    href={"mailto:formula@mcmaster.ca"}
                    className="glass-card"
                  >
                    <img
                      src={glassEffect}
                      className="glass-background"
                      alt=""
                      aria-hidden="true"
                    />
                    <div className="glass-card-content">
                      <img src={emailIcon} className="contact-icon" alt="Email" />
                      <span>formula@mcmaster.ca</span>
                    </div>
                  </a>


                  <a
                    href="https://www.instagram.com/macformulaelectric/?hl=en"
                    target="_blank"
                    rel="noreferrer"
                    className="glass-card"
                  >
                    <img
                      src={glassEffect}
                      className="glass-background"
                      alt=""
                      aria-hidden="true"
                    />
                    <div className="glass-card-content">
                      <img src={instagramIcon} className="contact-icon" alt="Instagram" />
                      <span>@macformulaelectric</span>
                    </div>
                  </a>

                  <a
                    href="https://www.linkedin.com/company/mac-formula-electric/"
                    target="_blank"
                    rel="noreferrer"
                    className="glass-card"
                  >
                    <img
                      src={glassEffect}
                      className="glass-background"
                      alt=""
                      aria-hidden="true"
                    />
                    <div className="glass-card-content">
                      <img src={linkedinIcon} className="contact-icon" alt="LinkedIn" />
                      <span>MAC Formula Electric</span>
                    </div>
                  </a>

                </div>

            </div>

            <p className='contact-description'>
              Connect with us on our social media platforms to stay updated!
            </p>

          </div>

        </div>
        <Footer/>
      </div>
    )
  }
}

export default ContactPage